import { render, staticRenderFns } from "./QuotationTransportCosts.vue?vue&type=template&id=46222170&"
import script from "./QuotationTransportCosts.vue?vue&type=script&lang=js&"
export * from "./QuotationTransportCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports